// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drawer-user-balance .v-list-item__subtitle[data-v-6929f3b6]{flex:1 1 100%;overflow:hidden;text-overflow:unset !important;white-space:unset !important}.view-benefits-btn[data-v-6929f3b6]{color:#fff !important;text-decoration:none}.view-benefits-btn .v-icon[data-v-6929f3b6]{margin-left:-4px;color:#fff !important}.view-benefits-btn[data-v-6929f3b6]:hover,.view-benefits-btn:hover .v-icon[data-v-6929f3b6]{color:#000 !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
